export default __webpack_public_path__ + "static/media/Midna_Laugh2.7d6ffb9a.wav";